import type { NltWorkflowPatchRequest, NltWorkflowProjection } from '../types/nltWorkflow';
import { normalizeOptimizationDatasetNames } from './optimizationDatasetName';
import { buildNltPatchDialog, type NltPatchDialogSourceMessage } from './nltPatchDialog';

/**
 * Body for `POST /nlt/workflow-patch`. Mirrors `buildNltGeneratePatchRequest`, minus
 * the `nlt_config` blob: this route resolves the admin NLT config itself and only
 * takes an optional `nlt_config_id`.
 */
export function buildNltWorkflowPatchRequest(params: {
  projection: NltWorkflowProjection;
  priorMessages: NltPatchDialogSourceMessage[];
  latestHuman: string;
  /** Digest of the snapshot the projection came from — echoed back, then used as the write lock. */
  baseRevision?: string | null;
  nltConfigId?: string;
  datasetNames?: string[];
}): NltWorkflowPatchRequest {
  const datasetNames = normalizeOptimizationDatasetNames(params.datasetNames);
  return {
    workflow: params.projection,
    dialog: buildNltPatchDialog(params.priorMessages, params.latestHuman),
    ...(params.nltConfigId ? { nlt_config_id: params.nltConfigId } : {}),
    ...(datasetNames.length > 0 ? { dataset_name: datasetNames } : {}),
    ...(params.baseRevision ? { base_revision: params.baseRevision } : {}),
    rag_enabled: false,
    lang: 'ru',
  };
}
